import RestClient from './RestClient'
import { AxiosRequestConfig } from 'axios'

const ENTRY_POINT = 'files/'

export default class FileService {
  config: AxiosRequestConfig = {
    headers: {
      'Content-Type': 'multipart/form-data',
      'Accept': 'text/plain'
    }
  }

  restClient: RestClient

  constructor(restClient: RestClient) {
    this.restClient = restClient
  }

  uploadFile(file: File, type: string): Promise<string> {
    const formData = new FormData()
    formData.append('file', file)
    return this.restClient.post(ENTRY_POINT, formData, { type }, this.config)
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/services/FileService.ts